import React from 'react';
import PropTypes from 'prop-types';
import Message from 'Components/Modal/Message';
import EnvironmentManager from 'Utils/environmentManager';

const TribunLeaderBoardMiniFailModal = props => {

  /*const buttonConfig = {
    primary: {
      label: 'LİDER 100’E GİT',
      onClick: props.onPrimaryButtonClick
    }
  };*/

  const failMessage = EnvironmentManager.getMessageText({ key: 'tribün_minisiralama_genelsiralama' });
  return (
    <Message type="none" >
      <p dangerouslySetInnerHTML={ { __html: failMessage } } />
    </Message>
  );
};

TribunLeaderBoardMiniFailModal.propTypes = {
  sortScore: PropTypes.string
};

export default TribunLeaderBoardMiniFailModal;
